import { LitElement, html, css } from 'lit'
import { nanoid } from 'nanoid'
export class AccordionItem extends LitElement {
  static styles = css`
    :host {
      display: block;
    }

    .body {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.35s linear;
    }

    slot[name='header'] {
      cursor: pointer;
    }
  `

  static properties = {
    open: { type: Boolean, reflect: true },
    group: { type: String, reflect: true },
    id: { type: String, reflect: true },
  }

  connectedCallback() {
    super.connectedCallback()
    this.open = this.open ?? false
    this.id = this.id ?? nanoid()
    if (this.group && this.id) {
      window.MicroBus.on(`${this.group}-accordion-group:toggle`, (e) => {
        if (this.id != e.detail.id && this.open && e.detail.open) {
          this._toggle()
        }
      })
    }
  }

  firstUpdated() {
    let headerSlot = this.querySelector('[slot="header"]')
    if (headerSlot) {
      headerSlot.setAttribute('role', 'button')
      headerSlot.setAttribute('tabindex', '0')
      headerSlot.setAttribute('aria-expanded', this.open ? 'true' : 'false')
      headerSlot.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          this._toggle()
        }
      })
    }

    let bodySlot = this.querySelector('[slot="body"]')
    bodySlot.querySelectorAll('a[href^="mailto:"]').forEach(link => {
      const email = link.href.replace('mailto:', '')
      link.setAttribute('aria-label', `Mail to ${email}`)
    })
    bodySlot.classList.add('loaded')
    if (this.open) {
      this._toggle(null, true)
    } else {
      bodySlot.setAttribute('aria-hidden', 'true')
      bodySlot.inert = true
    }
  }

  render() {
    return html`
      <slot name="header" @click=${this._toggle}></slot>
      <div class="body">
        <slot name="body"></slot>
      </div>
    `
  }

  _toggle(e, forceState) {
    this.open = forceState ?? !this.open
    let body = this.shadowRoot.querySelector('.body')
    let bodySlot = this.querySelector('[slot="body"]')
    let headerSlot = this.querySelector('[slot="header"]')
    if (this.open) {
      this.ariaExpanded = 'true'
      if (headerSlot) headerSlot.setAttribute('aria-expanded', 'true')
      body.style['max-height'] = body.scrollHeight + 'px'
      if (bodySlot) {
        bodySlot.setAttribute('aria-hidden', 'false')
        bodySlot.inert = false
      }
      if (this.group === 'mobile-menu-accordion' && window.gtag) {
        window.gtag('event', 'Navigation Section Open', { event_detail: this.dataset.eventDetail || '' })
      }
    } else {
      this.ariaExpanded = 'false'
      if (headerSlot) headerSlot.setAttribute('aria-expanded', 'false')
      body.style['max-height'] = ''
      if (bodySlot) {
        bodySlot.setAttribute('aria-hidden', 'true')
        bodySlot.inert = true
      }
    }
    //emit event that to the accordion group with current accordion item state
    if (this.group && this.id) {
      window.MicroBus.emit(`${this.group}-accordion-group:toggle`, { open: this.open, id: this.id })
    }
  }
}
customElements.define('accordion-item', AccordionItem)
